exports.list = {
  path: "/laporan_pembelian",
  name: "laporan_pembelian",
  meta: {
    authRequired: true,
  },
  component: () => import("@/views/main/laporan_pembelian/List.vue"),
};
  